import { render } from "./TableRender.vue?vue&type=template&id=55d691ea&ts=true"
import script from "./TableRender.vue?vue&type=script&lang=ts"
export * from "./TableRender.vue?vue&type=script&lang=ts"

import "./TableRender.vue?vue&type=style&index=0&id=55d691ea&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__